export default "__VITE_ASSET__xkqE98hd__"